import React, { useEffect, useState } from 'react';
import { requestToken, addData, setData } from '@/actions/auth';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Input, Spin } from 'antd';
import EmailCodeForm from './email-code-form';

const ForgotPasswordComponent = () => {
  useEffect(() => {
    clearState();
  }, []);

  const dispatch = useDispatch();
  const [email, setEmail] = useState('');
  const requestedToken = useSelector((state: any) => state?.auth?.tokenRequested);
  const requestTokenLoading = requestedToken?.loading;
  const requestTokenStatus = requestedToken?.status;
  const requestTokenError = requestedToken?.error;

  const handleSubmit = (event) => {
    event.preventDefault();
    const data = {
      email: email,
    };
    dispatch(requestToken(data));
  };

  const clearState = () => {
    dispatch(
      addData({
        key: 'tokenRequested',
        value: {},
      })
    );
    dispatch(
      setData({
        name: 'tokenRequested',
        key: 'status',
        value: false,
      })
    );
  };
  return (
    <div className="mt-0 mb-0" style={{ backgroundColor: '#f8f9fc' }}>
      <Spin spinning={requestTokenLoading ? true : false}>
        <div className="container main-banner mt-0">
          <div className="row">
            {!requestTokenStatus && (
              <div className="col-lg-6">
                <img src="https://s3.ap-south-1.amazonaws.com//studyinfocentre.com/Banner/Forget-password.png?w=640&q=75" />
              </div>
            )}
            <div
              className={`${
                !requestTokenStatus ? 'col-lg-6 m-auto' : 'col-lg-12 m-auto'
              }`}
            >
              {requestTokenStatus ? (
                <EmailCodeForm email={email} />
              ) : (
                <div className="banner-form border-14">
                  <div className="title forgot-password">
                    <h3 className="heading">Find Your Account</h3>
                  </div>
                  <form onSubmit={handleSubmit}>
                    <div className="form-group">
                      <label htmlFor="email">Email address</label>
                      <Input
                        onChange={(e) => setEmail(e.target.value)}
                        type="email"
                        id="email"
                        aria-describedby="emailHelp"
                        required
                        placeholder="Enter your Email Address."
                        size="large"
                        className="border-14"
                      />
                    </div>
                    {requestTokenError?.email ? (
                      <label className="validation mx-auto text-danger">
                        <i className="fas fa-exclamation-triangle"></i>{' '}
                        {requestTokenError?.email}
                      </label>
                    ) : (
                      ''
                    )}
                    <Button
                      htmlType="submit"
                      size="large"
                      className="btn-secondary border-danger btn-block border-14"
                    >
                      Send Code
                    </Button>
                  </form>
                </div>
              )}
            </div>
          </div>
        </div>
      </Spin>
    </div>
  );
};

export default ForgotPasswordComponent;
